<template>
  <div class="detailView">
    <div class="title">
      <img src="../img/titleMd.png" alt="">
    </div>
    <p class="back" @click="backDetail">返回案例分析 ></p>
    <p class="titlePic">
      <img v-lazy="caseInfo.TitlePic" :key="caseInfo.TitlePic" alt="">
    </p>
    <p class="titleName">{{caseInfo.Title}}</p>
    <el-divider class="divider">{{caseInfo.AddTime|timeFormat()}}</el-divider>

      <div class="newsItemShow">
        <div class="newsItemShowTop" v-if="caseInfo.ArticleType === 1">
            <video  :src="caseInfo.Video" controls ></video>
        </div>
        <div v-html="caseInfo.Content"></div>
    </div>

  </div>
</template>

<script>
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
export default {

  computed: {
    caseInfo () {
      return this.$store.state.caseInfo;//需要监听的数据
    }
  },
  filters: {
    timeFormat
  },
  methods: {
    backDetail () {
      this.$router.back()
    },
    }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.detailView{
  width: 100%;
   .title{
    width: 750px/$md;
    height: 300px/$md;
    margin-bottom: 40px/$md;
    img{
      width: 100%;
    }
  }
}
.titlePic{
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 30%;
    height: auto;
  }
}
.titleName{
    display: flex;
    justify-content: center;
    font-size: 30px/$md;
font-weight: 500;
text-align: center;
color: #333333;
}
.divider{
  width: 690px/$md;
  margin: 50px/$md auto;
}
.back{
height: 35px/$md;
font-size: 26px/$md;
font-weight: 400;
line-height: 24px/$md;
color: #666666;
padding-right: 30px/$md;
margin-top: 40px/$md;
margin-bottom: 50px/$md;
text-align: right;
}

// 富有文本
.newsItemShow{
    width: 690px/$md;
    min-height: 600px/$md;
    margin: auto;
}
.newsItemShowTop{
    display: flex;
    justify-content: center;
    video {
      width: 600px/$md;
      height: 350px/$md;
    }
}
</style>
